// Template Configuration
// Available templates for vCard display

export const cardTemplates = [
  {
    id: 'simple-identity',
    name: 'Simple Identity',
    description: 'Clean, minimal design with dark mode',
    free: true,
    isDefault: true,
    component: 'SimpleIdentity',
    coverImage: '/assets/1.jpg',
    previewColors: {
      primary: '#2b8cee',
      bg: '#f6f7f8',
      darkBg: '#101922'
    }
  },
  {
    id: 'modern-gradient',
    name: 'Modern Gradient',
    description: 'Vibrant purple gradient with wave',
    free: true,
    isDefault: false,
    component: 'ModernGradient',
    coverImage: '/assets/2.jpg',
    previewColors: {
      primary: '#667eea',
      secondary: '#764ba2',
      bg: '#ffffff'
    }
  },
  {
    id: 'dark-neon',
    name: 'Dark Neon',
    description: 'Sleek dark theme with neon glow',
    free: true,
    isDefault: false,
    component: 'DarkNeon',
    coverImage: '/assets/3.jpg',
    previewColors: {
      primary: '#00ff88',
      secondary: '#00d4ff',
      bg: '#0a0a0f'
    }
  },
  {
    id: 'teal-card',
    name: 'Teal Card',
    description: 'Clean centered card with teal accent',
    free: true,
    isDefault: false,
    component: 'TealCard',
    coverImage: '/assets/4.jpg',
    previewColors: {
      primary: '#14B8A6',
      bg: '#F7F8FC',
      darkBg: '#101922'
    }
  },
  {
    id: 'gold-metal',
    name: 'Gold Metal Plate',
    description: 'Premium luxury with 3D engraved effects',
    free: false,
    isDefault: false,
    component: 'GoldMetal',
    coverImage: '/assets/5.jpg',
    previewColors: {
      primary: '#D4AF37',
      secondary: '#B8860B',
      bg: '#1a1a1a'
    }
  },
  {
    id: 'black-marble',
    name: 'Black Marble',
    description: 'Modern luxury with gold accents',
    free: false,
    isDefault: false,
    component: 'BlackMarble',
    coverImage: '/assets/6.jpg',
    previewColors: {
      primary: '#D4AF37',
      secondary: '#0a0a0a',
      bg: '#0a0a0a'
    }
  }
]

export default cardTemplates
